module.exports = __webpack_public_path__ + "static/media/without-box.2fc128c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/without-box.png
// module id = 374
// module chunks = 0